module.exports = __webpack_public_path__ + "assets/media/day31.9d841491.mp3";